export enum MessageType {
  SEND_INVOICE_WHATSAPP = 'SEND_INVOICE_WHATSAPP'
}

